// extracted by mini-css-extract-plugin
export default {"details":"style--details--292d96","withTodayBadge":"style--withTodayBadge--39eff8"};